import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { NewsPopupComponent } from './news-popup.component';
import { NewsPopupService } from './news-popup.service';

@NgModule({
  declarations: [NewsPopupComponent],
  imports: [CommonModule, TranslateModule],
  exports: [NewsPopupComponent],
  providers: [NewsPopupService]
})
export class NewsPopupModule {}
